// @flow
import React from "react"
import { InputField, Label, FormGroup, Error } from "../UI/Form"
import { PrimaryButton } from "../UI/Buttons"
import { Field, reduxForm } from "redux-form"
import { validate } from "./validations"

const LoginForm = ({ error, handleSubmit }) =>
  <form onSubmit={handleSubmit}>
    <FormGroup>
      <Label htmlFor="email">Email Address</Label>
      <Field name="email" component={InputField} type="email" />
    </FormGroup>
    <FormGroup>
      <Label htmlFor="password">Password</Label>
      <Field name="password" component={InputField} type="password" />
    </FormGroup>
    {error &&
      <Error>
        {error}
      </Error>}
    <PrimaryButton block={true}>Login</PrimaryButton>
  </form>

export default reduxForm({
  form: "login",
  validate: validate({ includePassword: true })
})(LoginForm)



// WEBPACK FOOTER //
// ./src/PublicArea/LoginForm.js